import { InputLabel, MenuItem, Select , FormControl} from '@mui/material'
import React from 'react'

export default function FormController({currency, handleCurrencyChange}: any) {
    const CONTROL_HEIGHT = 30;   // match Download button
    const PILL_RADIUS = 28;
  return (
     <FormControl
        size="small"
        sx={{
          
    '& .MuiInputLabel-root.Mui-focused': {
      color: 'black',
    },
          minWidth: 120, // gives room for label + value; adjust if needed
          // Align the whole control vertically with the Download button
          // Ensure the outlined input uses our custom height & radius
          // "& .MuiOutlinedInput-root": {
          //   height: CONTROL_HEIGHT,
          //   borderRadius: PILL_RADIUS,
          // },
          // Control the actual input area (content box) to center the text
          // "& .MuiSelect-select": {
          //   display: "flex",
          //   alignItems: "center",
          //   paddingTop: 0,
          //   paddingBottom: 0,
          //   paddingLeft: "12px",
          //   paddingRight: "28px", // leave space for the dropdown icon
          //   lineHeight: 1,
          //   height: CONTROL_HEIGHT,
          // },
          // Label alignment (so it sits nicely above with small gap)
          "& .MuiInputLabel-root": {
             color: 'black',
            top: -6, // lift the label slightly to match your screenshot
          },
          "& .MuiInputLabel-shrink": {
            transform: "translate(14px, -4px) scale(0.85)",
          },
          // Icon sizing and vertical centering
          "& .MuiSelect-icon": {
            right: 10,
            fontSize: 18, // close to the Download arrow treatment
          },
          // Border color to match your screenshot’s subtle outline
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(0,0,0,0.23)",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(0,0,0,0.35)",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(0,0,0,0.4)",
          },

          '& .MuiOutlinedInput-root': {
          height: CONTROL_HEIGHT,
          borderRadius: PILL_RADIUS,
          color: 'black',
           '& fieldset': {
        borderColor: 'black',
      },
      '&:hover fieldset': {
        borderColor: 'black',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'black',
      },
        },
        '& .MuiSelect-select': {
          display: 'flex',
          alignItems: 'center',
          paddingTop: 0,
          paddingBottom: 0,
          height: CONTROL_HEIGHT,
          color: 'black',
        },
        }}
      >
        <InputLabel>Currency</InputLabel>
        <Select value={currency} onChange={handleCurrencyChange} label="Currency">
          <MenuItem value="USD">USD</MenuItem>
          <MenuItem value="LOCAL">Local</MenuItem>
        </Select>
      </FormControl>
  )
}
